/**
 * App.tsx — composition root. Providers + a single NavigationContainer hosting
 * the root navigator. All routing lives under src/navigation. SK Upsell owns no
 * auth: rootNavigator gates on the platform session.
 */
import React from 'react';
import { NavigationContainer } from '@react-navigation/native';

import { ThemeProvider } from './src/context/themeContext';
import { AppProvider } from './src/context/appContext';
import { SessionProvider } from './src/context/sessionContext';
import { CountsProvider } from './src/context/countsContext';
import GlobalErrorBoundary from './src/components/globalErrorBoundary';
import ToastHost from './src/components/toastHost';
import RootNavigator from './src/navigation/rootNavigator';
import { navigationRef } from './src/navigation/navigationRef';

export default function App() {
  return (
    <GlobalErrorBoundary>
      <ThemeProvider>
        <AppProvider>
          <SessionProvider>
            <CountsProvider>
              <NavigationContainer ref={navigationRef}>
                <RootNavigator />
              </NavigationContainer>
              {/* Metro picks toastHost.web.tsx on web (portals above modals). */}
              <ToastHost />
            </CountsProvider>
          </SessionProvider>
        </AppProvider>
      </ThemeProvider>
    </GlobalErrorBoundary>
  );
}
